#import "./availability-report-day-snapshot-fragment.graphql"

fragment AvailabilityReportDayFragment on BookingDay {
    date
    isBookable
    conversionRate
    views {
        count
        heatmap
    }
    bookings {
        count
        heatmap
    }
    availabilitySnapshot {
        ...AvailabilityReportDaySnapshotFragment
    }
}
